export function getDate() {
    const d = new Date()
    const rawMonth = d.getMonth() + 1
    const rawDay = d.getDate()
    const month = rawMonth < 10 ? `0${rawMonth}` : rawMonth
    const day = rawDay < 10 ? `0${rawDay}` : rawDay

    return `${d.getFullYear()}-${month}-${day}`
}